<template>
  <div>
    <RequestInfo :loader="loading" />
    <b-table
      v-if="resultList.length > 0"
      class="departures"
      id="departuresTable"
      primary-key="index"
      small
      sticky-header
      :items="resultList"
      :fields="fields"
      thead-class="d-none"
      tbody-tr-class="departure-row"
      :selectable="expandable"
      select-mode="single"
      @row-selected="onRowSelected"
      :busy="loading"
    >
      <template v-slot:cell(aika)="data">
        <div :class="{ 'rt-found': data.item.estimateTime != 'null' }">
          <div class="time">{{ data.item.aika }}</div>
          <div class="rt-time">{{ data.item.estimateTime }}</div>
        </div>
      </template>

      <template v-slot:cell(maaranpaa)="data">
        <div>{{ data.item.maaranpaa }}</div>
        <div>
          <VehicleBrief :label="data.item.vehicleLabel"> </VehicleBrief>
        </div>
      </template>

      <template v-slot:cell(course)="data">
        <div>{{ data.item.tripShortName }}</div>
      </template>

      <template #row-details="row" v-if="$UIPrivilege('realtime/stop_updates')">
        <PredictionHistory
          :stopId="row.item.stopId"
          :lineId="row.item.lineId"
          :routeId="row.item.routeId"
          :passingTime="row.item.passTime"
        >
        </PredictionHistory>
      </template>
    </b-table>
    <span v-if="!loading && resultList.length == 0" class="info note">{{
      $t('timetables.no_departures')
    }}</span>

    <!-- <RequestInfo v-if="resultList.length == 0" /> -->
  </div>
</template>

<script>
import stop from '@/store/timetable/stop'
import timetable from '@/store/timetable/timetable'
import VehicleBrief from '@/components/Realtime/VehicleBrief'
const PredictionHistory = () =>
  import('@/components/Timetable/PredictionHistory.vue')
import utils from '@/plugins/TravellerUtils.js'
import moment from 'moment'

export default {
  name: 'StopDeparturesList',
  components: { VehicleBrief, PredictionHistory },
  data: function () {
    let fields = [
      { key: 'aika', tdClass: 'time' },
      { key: 'linja', tdClass: 'line' },
      { key: 'maaranpaa', tdClass: 'dest' },
    ]
    if (this.$UiConfig('/data/departure/showCourse', false)) {
      fields.push({ key: 'course', tdClass: 'line' })
    }
    return {
      fields: fields,
      routeList: null,
      departureList: null,
      lineList: null,
      resultList: [],
      loading: false,
      getDataIntervalId: null,
    }
  },
  props: {
    stopTunnus: { default: null },
    expandable: {
      type: Boolean,
      default: true,
    },
    opened: {
      type: Boolean,
      default: true,
    },
    // msg: {type: number, default: null}
  },
  beforeCreate: function () {
    if (!this.$store.state.stop) {
      this.$store.registerModule('stop', stop)
    }
    if (!this.$store.state.timetable) {
      this.$store.registerModule('timetable', timetable)
    }
  },
  created() {
    if(this.opened) {
      this.getData()
      this.setGetDataInterval()
    }
  },
  watch: {
    stopTunnus() {
      if(this.opened){
        this.getData()
      }
    },
    opened(newVal) {
      if(newVal) {
        this.getData()
        this.setGetDataInterval()
      } else {
        this.clearGetDataInterval()
      }
    }
  },
  beforeDestroy() {
    this.clearGetDataInterval()
  },
  computed: {},
  methods: {
    getData(visible = true) { 
      let stopTunnus = this.$props.stopTunnus

      if(visible) {
        this.loading = true
        this.resultList = []
      }
      const stopDeps = this.$store.dispatch(
        'stop/getStopDepartures',
        stopTunnus
      )
      // Nouda reittilistata
      const routes = this.$store.dispatch('timetable/getRoutesWithDestinations')
      // Nouda linjat
      const lines = this.$store.dispatch('timetable/getLinesListData')
      Promise.all([stopDeps, routes, lines]).then((data) => {
        this.departureList = data[0]
        this.routeList = data[1]
        this.lineList = data[2]
        this.mergeData()
        this.currentTimeIndicator()
        this.loading = false
      })
    },
    currentTimeIndicator() {
      this.$nextTick(() => {
        var table = document.getElementById('departuresTable')
        if (table) {
          let time = new Date().getTime()
          
          // find next departure
          let index = this.resultList.findIndex(
            (d) => d.passTime.valueOf() > time
          )

          // scroll to current departures - reduced by 5 to see past departures
          let show = index - 5
          if (show < 0) show = 0
          let parent = table.parentElement
          try {
            let parentRect = parent.getBoundingClientRect()
            let parentViewableArea = {
              height: parent.clientHeight,
              width: parent.clientWidth,
            }
            var childRect = table.rows[show].getBoundingClientRect()          
            var isViewable =
              childRect.top >= parentRect.top &&
              childRect.top <= parentRect.top + parentViewableArea.height
            if (!isViewable) {
              parent.scrollTop =
                childRect.top + parent.scrollTop - parentRect.top
            }
          } catch {
            this.$notify({
              title: this.$t('notify.passing_line_error'),
              message: this.$t('notify.passing_line_error'),
              type: 'danger',
              timeout: 2000,
            })
          }
          // clear previous indicator classess
          let clear = document.querySelectorAll('.next')
          clear.forEach((e) => {
            e.classList.remove('next')
          })
          clear = document.querySelectorAll('.prev')
          clear.forEach((e) => {
            e.classList.remove('prev')
          })

          // place indicator classes
          let next = index + 1
          if (next < 0) next = 0
          table.rows[next].classList.add('next')
          table.rows[next - 1].classList.add('prev')
        }
      })
    },
    scrollToCurrentDeparture() {
      let index = 0
      const now = moment()
      let lastBefore = 0
      for (let dep of this.resultList) {
        index = index + 1
        dep.index = index
        if (dep.passTime.isBefore(now)) {
          lastBefore = index
        }
      }

      const selector = '#departures__row_' + lastBefore
      setTimeout(() => {
        let element = this.$el.querySelector(selector)
        if (element) {
          element.scrollIntoView()
        }
      }, 500)
    },
    getTime(value) {
      if (!value || value == 'null') return ''
      return value
    },
    mergeData() {
      if (this.routeList == null || this.departureList == null) {
        return
      }
      const result = new Array()
      const $vm = this
      this.departureList.forEach((dep) => {
        const row = {}
        row.aika = dep.pass_time
        const reitti = $vm.routeList.find((r) => {
          return r.tunnus == dep.routeTunnus
        })
        const linja = $vm.lineList.find((l) => {
          return reitti.linja == l.tunnus
        })
        row.linja = linja.tunnusteksti
        row.platform = dep.rtPlatform
        if (dep.destinations && dep.destinations.length > 0) {
          const destinationWithLanguage = dep.destinations.reduce(
            (destWithMinLangCode, currentDest) => {
              return currentDest.languageCode < destWithMinLangCode.languageCode
                ? currentDest
                : destWithMinLangCode
            },
            dep.destinations[0]
          )
          row.maaranpaa = destinationWithLanguage.name.toString()
        } else {
          row.maaranpaa = ''
        }

        row.estimateTime = dep.corr_time
        row.vehicleLabel = dep.vehicleLabel
        row.rtDepartureId = dep.rtDepatureId
        row.tripShortName = dep.tripShortName
        row.stopId = dep.stopTunnus
        row.lineId = linja.tunnus
        row.routeId = reitti.tunnus
        row.passTime = utils.dateFromRtDateTime(dep.pass_date, dep.pass_time)
        row._showDetails = false
        result.push(row)
      })
      this.resultList = result.sort((a, b) => {
        if (a.passTime && b.passTime) {
          const timeA = new Date(a.passTime).getTime()
          const timeB = new Date(b.passTime).getTime()

          return timeA - timeB
        }

        return 0
      })
    },
    onRowSelected(selectedRows) {
      if (this.expandable) {
        this.resultList.map((item) => {
          item._showDetails = false
          return item
        })
        if (selectedRows.length > 0)
          this.resultList.find(
            (item) => item.rtDepartureId == selectedRows[0].rtDepartureId
          )._showDetails = true
      }
    },
    setGetDataInterval() {
      this.clearGetDataInterval()
      this.getDataIntervalId = setInterval(() => this.getData(false), 14000)
    },
    clearGetDataInterval() {
      if(this.getDataIntervalId != null) {
        clearInterval(this.getDataIntervalId)
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.departures {
  height: 76vh;
  max-height: 76vh;
}
</style>
